/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
/**
 * Indicates the action the enter key should take when the Enter key is pressed.
 */
export var EnterKeyBehaviors = /*@__PURE__*/ (function (EnterKeyBehaviors) {
    /**
     * The Enter key does nothing.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["None"] = 0] = "None";
    /**
     * Place the active cell into edit mode when the Enter key is pressed if edit mode is enabled.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["Edit"] = 1] = "Edit";
    /**
     * Moves the active cell down after the Enter key is pressed.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["MoveDown"] = 2] = "MoveDown";
    /**
     * Moves the active cell to the right after the Enter key is pressed.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["MoveRight"] = 3] = "MoveRight";
    /**
     * Moves the active cell up after the Enter key is pressed.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["MoveUp"] = 4] = "MoveUp";
    /**
     * Moves the active cell to the left after the Enter key is pressed.
     */
    EnterKeyBehaviors[EnterKeyBehaviors["MoveLeft"] = 5] = "MoveLeft";
    return EnterKeyBehaviors;
})({});
/**
 * @hidden
 */
export var EnterKeyBehaviors_$type = /*@__PURE__*/ markEnum('EnterKeyBehaviors', 'None,0|Edit,1|MoveDown,2|MoveRight,3|MoveUp,4|MoveLeft,5');
//# sourceMappingURL=EnterKeyBehaviors.js.map
